
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Editable extends Vue {

    @Prop({default: null})
    content: string;

     @Prop({default: false})
    disabled: string;

    mounted() {
        // if (this.content) {
        //     this.$el.innerText = this.content;
        // } else {
        //     this.$el.innerText = "";
        // }
    }
    update(event) {
        this.$emit('update', event.target.innerText);
    }
}
